var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "nav-item", class: { active: _vm.isActive } },
    [
      _c(
        "button",
        {
          staticClass: "nav-link btn btn-default btn-round btn-200",
          attrs: {
            "data-target": _vm.targetName,
            "data-toggle": "tab",
            role: "tab",
            id: _vm.idName
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.switchTab($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.sectionName))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }